import { Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import Select from 'components/Select/Select';
import TextField from 'components/TextField/TextField';
import { NGO_NAME, REPRESENTATION_CATEGORY } from 'constants/formFields';
import { OPTION_CATEGORY_NOGS } from 'constants/general';

import type IFieldError from 'store/types/IFieldError';
import type IFormNGO from '../interfaces/IFormNGO';

import styles from '../scss/CreateNGO.module.scss';

function RowForm({ control }: IFormNGO) {
  const { t } = useTranslation();
  return (
    <>
      <div className={styles.leftColumn}>
        <Controller
          control={control}
          name={NGO_NAME}
          render={({
            field: {
              name,
              value,
              onChange,
            },
            fieldState: { error },
          }) => (
            <TextField
              name={name}
              value={value}
              label={t('materialityAssessment.fields.ngoName')}
              error={error?.message}
              onChange={(event) => onChange(event.target.value)}
              placeholder={t('materialityAssessment.placeholder.typeHere')}
              required
            />
          )}
        />
      </div>
      <div className={styles.rightColumn}>
        <Controller
          control={control}
          name={REPRESENTATION_CATEGORY}
          render={({
            field: {
              value,
              onChange,
            },
            fieldState: { error },
          }) => (
            <Select
              label={t('materialityAssessment.fields.representationCategory')}
              placeholder={t('materialityAssessment.placeholder.selectDepartment')}
              options={OPTION_CATEGORY_NOGS}
              value={value?.value ? value : undefined}
              onChange={onChange}
              error={(error as IFieldError)?.value?.message}
              menuPosition="absolute"
              required
            />
          )}
        />
      </div>
    </>

  );
}

export default RowForm;
